import React from 'react'
import MorseTrainerApp from './Pages/MorseTrainer/morse'
export default function App() {
  return (
    <div>
      <MorseTrainerApp/>
    </div>
  )
}

